export const RECEIVE_SENDGRID_API_KEY = "RECEIVE_SENDGRID_API_KEY"
export const UPDATE_SENDGRID_API_KEY = "UPDATE_SENDGRID_API_KEY"

export const updateSendgridApiKey = (success, error) => ({
  type: UPDATE_SENDGRID_API_KEY,
  success,
  error,
})

export const receiveSendgridApiKey = (response) => ({
  type: RECEIVE_SENDGRID_API_KEY,
  response,
})
